import * as React from "react";
import { Button } from "@grandvisionhq/common";
import "../../../../events/events/event-properties-provider.js";
import { useDispatchTrackClickEvent } from "../../../../events/events/use-track-click-event.js";
const TealiumButton = ({ tealiumEvent, ...props }) => {
  const { onClick, ...rest } = props;
  const dispatchTrackClickEvent = useDispatchTrackClickEvent();
  const handleClick = (event) => {
    if (tealiumEvent) {
      try {
        dispatchTrackClickEvent({
          ...tealiumEvent,
          Tracking_Type: "link"
        });
      } catch (error) {
        console.error("Tealium dispatch error:", error);
      }
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /* @__PURE__ */ React.createElement(Button, { ...rest, onClick: handleClick });
};
export {
  TealiumButton
};
//# sourceMappingURL=TealiumButton.js.map
